import { motion } from "framer-motion";

import type { ReportNextTopic } from "@/lib/api";
import { cn } from "@/lib/formatters";

interface NextTopicCardProps {
  topic: ReportNextTopic | null;
}

const CATEGORY_HUE: Record<string, string> = {
  ai:         "text-primary border-primary/40 bg-primary/5",
  automation: "text-violet border-violet/40 bg-violet/5",
  webdev:     "text-magenta border-magenta/40 bg-magenta/5",
  seo:        "text-success border-success/40 bg-success/5",
  digital:    "text-warn border-warn/40 bg-warn/5",
};

export function NextTopicCard({ topic }: NextTopicCardProps) {
  if (!topic) return null;
  const catClass = CATEGORY_HUE[topic.category] ?? "text-muted border-border bg-bg-elev/40";

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className="surface p-5 relative overflow-hidden shadow-glow-magenta"
    >
      <span className="absolute top-3 right-3 flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wider text-magenta">
        <span className="w-1.5 h-1.5 rounded-full bg-magenta animate-pulse-led" />
        suggested next topic
      </span>

      <div className="flex items-start gap-2 flex-wrap mt-6">
        <span className={cn(
          "inline-block px-1.5 py-0.5 rounded-sm font-mono text-[10px] uppercase border",
          catClass,
        )}>
          {topic.category}
        </span>
        <p className="text-2xl font-mono text-text num-hero-magenta w-full mt-1">
          {topic.keyword}
        </p>
      </div>

      <p className="mt-3 text-sm text-muted/90 leading-relaxed">
        {topic.reason}
      </p>
    </motion.div>
  );
}
